import { Component, Input } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { keyDescOrder } from 'src/app/shared/helpers/helper';
import { SortOrder } from 'src/app/shared/modules/graphql/enums/generic.enums';
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsFilterType, IApiInvestigationMetricsOrderBy } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { InvestigationMetricsContactService } from 'src/app/shared/services/reports';
import { InvestigationMetricsContactDatasource } from 'src/app/shared/services/reports/investigation-metrics/investigation-metrics-contact/investigation-metrics-contact.datasource';

@Component({
  selector: 'app-investigation-metrics-contact',
  templateUrl: './investigation-metrics-contact.component.html',
  styleUrls: ['./investigation-metrics-contact.component.scss']
})
export class InvestigationMetricsContactComponent {

  private _dataSource: InvestigationMetricsContactDatasource;
  public set dataSource(val) {
    this._dataSource = val;
  }
  public get dataSource() {
    return this._dataSource;
  }

  public get pageOptions() {
    if (!this.dataSource) return null;
    return this.dataSource.listPage;
  }

  public sort: SortDescriptor[] = [{
    field: IApiInvestigationMetricsOrderBy.ContactName,
    dir: 'asc'
  }];

  public tableData = [];

  public yearsArray;

  public keyDescOrder = keyDescOrder;

  @Input() tabIndex;

  constructor(
    private loaderService: LoaderService,
    private investigationMetricsContactService: InvestigationMetricsContactService,
    private notifications: NotificationsService
  ) {
    this.dataSource = new InvestigationMetricsContactDatasource(this.investigationMetricsContactService);
    this.loaderService.attachObservable(this.dataSource.loading$);
    this.dataSource.listPage.orderBy = IApiInvestigationMetricsOrderBy.ContactName;
  }

  public load() {
    this.dataSource.load().then(() => {
      this.dataSource?.contents$.subscribe((res) => {
        this.tableData = res;
        this.tableData = this.tableData?.map((row) => {
          return {
            ...row,
            data: JSON.parse(row?.data)
          }
        })
      });
    });
  }

  public sortChange = (e) => {
    this.sort = e;
    if (e && e?.[0]?.dir) {
      this.dataSource.listPage.orderBy = e?.[0]?.field;
      this.dataSource.listPage.sortOrder =
        e?.[0]?.dir === "asc" ? SortOrder.ASC : SortOrder.DESC;
    } else {
      this.dataSource.listPage.orderBy = IApiInvestigationMetricsOrderBy.ContactName;
      this.dataSource.listPage.sortOrder = SortOrder.ASC;
    }
    this.load();
  };

  public pageChange(event) {
    this.pageOptions?.paginate(event)
  }

  applyFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    filters?.map(filter => this.dataSource.applyFilter(filter?.type, filter?.value));
    this.dataSource.pagingReset();
    this.load();
  }

  clearFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    this.dataSource.pagingReset();
    this.load();
  }

  public exportXlsx() {
    const filters = this.dataSource?.lastFilters;
    const finalFilters = [...filters, { type: IApiInvestigationMetricsFilterType.ReportExport, value: 'true' }]
    this.investigationMetricsContactService.get(finalFilters).subscribe((res) => {
      this.notifications.kendoConfirm("Your report export has been successfully queued. You will receive a confirmation email when it is ready.", "Report Export", "", "Ok").subscribe();
    }, error => {
      console.log(error);
      this.notifications.alert("Report Export Failed", "An error occurred while exporting the report. Please try again later.");
    });
  }

}
